/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scheduleResponseSchema = z.object({
  forecastedFinishDateTime: z.iso.datetime(),
  forecastedStartDateTime: z.iso.datetime(),
  itemId: z.int(),
  latestFinishDateTime: z.iso.datetime(),
});
